import GeneralTracker from '../GeneralTracker';


export default class DirectorySortingTracker extends GeneralTracker {
  CAPTURE_NAME = 'ui:directory:sorting:usage';
  VERSION = '1';

  setHandlers() {
    const service = this.getService();
    service.on('toggleSortingMenu', this.passthrough);
    service.on('selectSortingOption', this.onSelect);
  }

  onSelect = (payload) => {
    const trackPayload = {
      action: 'select',
      tag: { ...payload },
    };

    this.track(trackPayload);
  };
}
